import { useState } from 'react';
import { Card, InputAdornment, OutlinedInput, Stack } from '@mui/material';
import { DataGrid, DataGridProps, useGridApiRef } from '@mui/x-data-grid';
import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity';
import { MagnifyingGlass as MagnifyingGlassIcon } from '@phosphor-icons/react/dist/ssr/MagnifyingGlass';

type DataGridInMemoryProps = DataGridProps & { showQuickSearch?: boolean; searchPlaceholder?: string };

export const DataGridArrayColumnSortComparator = (a: unknown, b: unknown) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length - b.length;
  }

  return 0;
};

export const DataGridInMemory: React.FC<DataGridInMemoryProps> = ({ showQuickSearch = true, ...props }) => {
  const pageSizeOptions = [10, 25, 50];

  const initialState: GridInitialStateCommunity = {
    pagination: { paginationModel: { pageSize: 10 } },
    ...props.initialState,
  };

  const [filter, setFilter] = useState('');

  const apiRef = useGridApiRef();

  const handleFilterChange = (value: string) => {
    setFilter(value);
    if (apiRef.current) {
      apiRef.current.setQuickFilterValues([value]);
    }
  };

  return (
    <Stack direction={'column'} gap={2}>
      {showQuickSearch && (
        <Card sx={{ p: 2 }}>
          <OutlinedInput
            value={filter}
            fullWidth
            placeholder={props.searchPlaceholder ?? 'Search'}
            startAdornment={
              <InputAdornment position="start">
                <MagnifyingGlassIcon fontSize="var(--icon-fontSize-md)" />
              </InputAdornment>
            }
            onChange={(ev) => handleFilterChange(ev.target.value)}
          />
        </Card>
      )}

      <DataGrid
        apiRef={apiRef}
        checkboxSelection
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        pageSizeOptions={pageSizeOptions}
        initialState={initialState}
        {...props}
      />
    </Stack>
  );
};
